/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExternalGroupAvatar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10v-2H6.099c.138-.678.421-1.295.844-1.783C7.547 17.521 8.51 17 10 17c1.7 0 2.728.678 3.314 1.556l1.663-1.112C13.993 15.971 12.32 15 10 15c-2.01 0-3.547.729-4.568 1.908-.77.889-1.203 1.98-1.362 3.092H4V4h16v11h2V4a2 2 0 0 0-2-2H4zm11.5 13a3.49 3.49 0 0 1-2.471-1.021c.536-.41.988-.924 1.322-1.514a1.5 1.5 0 1 0 .648-2.38L15 10a4.99 4.99 0 0 0-.37-1.891A3.5 3.5 0 1 1 15.5 15zM10 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm13.586 9H16v2h3.586l-1.293 1.293 1.414 1.414 3-3 .707-.707-.707-.707-3-3-1.414 1.414L19.586 19z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExternalGroupAvatar as ExternalGroupAvatar };
